import LoginForm from "./_components/LoginForm";
import unsplash from "/images/unsplash.png?url";

function Login() {
  return (
    <div className="flex flex-col h-screen">
      <div
        // className="flex h-screen basis-1/2 items-center justify-center"
        className="flex h-screen items-center justify-center"
      >
        <LoginForm />
      </div>
      {/* <div
        style={{
          backgroundImage: `url(${unsplash})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="h-screen basis-1/2"
      /> */}
    </div>
  );
}

export default Login;
